<template>
  <ButtonComponent class="textCenter w100 mb-10" mod="gradient-bg" @click="addMpk">Создать профиль МПК</ButtonComponent>

  <ButtonComponent class="textCenter w100 mb-10" mod="gradient-bg" @click="addEvent"
    >Создать мероприятие</ButtonComponent
  >

  <ButtonComponent class="textCenter w100 mb-10" mod="gradient-bg" @click="addProject"
    >Создать карточку проекта</ButtonComponent
  >
</template>

<script>
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';

  export default {
    name: 'Widget1',
    components: {
      ButtonComponent,
    },
    props: {
      countryId: {
        type: Number,
        default: null,
      },
    },
    methods: {
      addMpk() {
        this.$router.push({
          name: 'CommissionCard',
          params: { id: 0, type: 'mp', action: 'edit' },
          query: { countryId: this.countryId },
        });
      },
      addEvent() {
        this.$router.push({ name: 'EventCardAdd', query: { countryId: this.countryId } });
      },
      addProject() {
        this.$router.push({ name: 'EditProjectCard', params: { id: 0 }, query: { countryId: this.countryId } });
      },
    },
    data() {
      return {};
    },
    created() {},
  };
</script>

<style lang="scss" scoped></style>
